import axios from 'axios';
import { config } from '../helper/configVariable.js'

const BASE_URL = config.BASE_URL;
//http://localhost:3020
async function fetchAPI(endpoint, method, body = null) {
    try {
        const authToken = localStorage.getItem('access_token');
        const headers = {
            'Content-Type': 'application/json',
        };
        if (authToken) {
            headers['Authorization'] = `Bearer ${authToken}`;
        }
        const response = await axios({
            method: method,
            url: `${BASE_URL}/${endpoint}`,
            headers: headers,
            data: body
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching data:', error);
        return null;
    }
}

export async function createSocialAccount(data) {
    return await fetchAPI('createSocialAccount', 'POST', { data });
}

export async function sendEmail(emailObject) {
    const { recipient, cc, bcc, subject, message, attachment } = emailObject;
    const user = JSON.parse(localStorage.getItem('user'));
    const from = user.wallet.username;
    const formData = new FormData();

    for (let i = 0; i < attachment.length; i++) {
        formData.append('files', attachment[i]);
    }

    formData.append('subject', subject);
    formData.append('recipient', recipient);
    formData.append('cc', cc);
    formData.append('bcc', bcc);
    formData.append('message', message);
    formData.append('from', from);

    try {
        const authToken = localStorage.getItem('access_token');
        const headers = {
            'Content-Type': 'multipart/form-data',
        };
        if (authToken) {
            headers['Authorization'] = `Bearer ${authToken}`;
        }
        const response = await axios.post(`${BASE_URL}/sendEmail`, formData, {
            headers: headers
        });
        console.log('Files uploaded successfully', response.data);
        return response;
    } catch (error) {
        console.error('Error uploading files', error);
        return null;
    }
}

export async function existUsername(username) {
    return await fetchAPI('existUsername', 'POST', { username });
}

export async function createDbmailUser(username, social_id) {
    return await fetchAPI('createDbmailUser', 'POST', { username, social_id });
}

export async function getEmails(user_name, type, searchTerm = '', offset = null) {
    return await fetchAPI('getEmails', 'POST', { user_name, type, searchTerm, offset });
}

export async function decrypt(privateKey, message) {
    return await fetchAPI('decrypt', 'POST', { privateKey, message });
}

export async function getS3File(name, url) {
    return await fetchAPI('getS3Data', 'POST', { name, url });
}

export async function stringToFile(file, fileName) {

    const formData = new FormData();
    formData.append('file', file);
    formData.append('fileName', fileName);

    try {
        const authToken = localStorage.getItem('access_token');
        const headers = {
            'Content-Type': 'multipart/form-data',
        };
        if (authToken) {
            headers['Authorization'] = `Bearer ${authToken}`;
        }
        const response = await axios.post(`${BASE_URL}/stringToFile`, formData, {
            headers: headers,
            responseType: 'blob'
        });
        return response;

    } catch (error) {
        console.error('Error uploading files', error);
    }
}

export async function updateMail(type, id) {
    return await fetchAPI('updateMail', 'POST', { type, id });
}

export async function storeDraft(emailDetails) {
    const userdata = JSON.parse(localStorage.getItem('user'));
    const user = userdata.wallet.username;
    return await fetchAPI('storeDraft', 'POST', { user, emailDetails });
}

export async function updateDraft(id, emailDetails) {
    return await fetchAPI('updateDraft', 'POST', { id, emailDetails });
}

export async function storeQuickSent(email) {
    const userdata = JSON.parse(localStorage.getItem('user'));
    const user = userdata.wallet.username;
    return await fetchAPI('storeQuickSent', 'POST', { user, email });
}

export async function storeCategory(name) {
    const userdata = JSON.parse(localStorage.getItem('user'));
    const user = userdata.wallet.username;
    return await fetchAPI('storeCategory', 'POST', { user, name });
}

export async function updateCategry(messageId, categryId) {
    return await fetchAPI('updateCategry', 'POST', { messageId, categryId });
}

export async function getCategoryEmails(email, categoryId, searchTerm = '', offset = null) {
    return await fetchAPI('getCategoryEmails', 'POST', { email, categoryId, searchTerm, offset });
}

export async function saveGeneralSettings(details) {
    const userdata = JSON.parse(localStorage.getItem('user'));
    const user = userdata.wallet.username;
    return await fetchAPI('saveGeneralSettings', 'POST', { user, details });
}

export async function getGeneralSettings() {
    const userdata = JSON.parse(localStorage.getItem('user'));
    const user = userdata.wallet.username;
    return await fetchAPI('getGeneralSettings', 'POST', { user });
}

export async function saveProfileSettings(details) {
    const userdata = JSON.parse(localStorage.getItem('user'));
    const user = userdata.wallet.username;
    return await fetchAPI('saveProfileSettings', 'POST', { user, details });
}

export async function getProfileSettings() {
    const userdata = JSON.parse(localStorage.getItem('user'));
    const user = userdata.wallet.username;
    return await fetchAPI('getProfileSettings', 'POST', { user });
}

export async function saveBlockedAddress(details) {
    const userdata = JSON.parse(localStorage.getItem('user'));
    const user = userdata.wallet.username;
    return await fetchAPI('saveBlockedAddress', 'POST', { user, details });
}

export async function getBlockedAddress() {
    const userdata = JSON.parse(localStorage.getItem('user'));
    const user = userdata.wallet.username;
    return await fetchAPI('getBlockedAddress', 'POST', { user });
}

export async function saveSignature(details) {
    const userdata = JSON.parse(localStorage.getItem('user'));
    const user = userdata.wallet.username;
    return await fetchAPI('saveSignature', 'POST', { user, details });
}

export async function getSignature() {
    const userdata = JSON.parse(localStorage.getItem('user'));
    const user = userdata.wallet.username;
    return await fetchAPI('getSignature', 'POST', { user });
}

export async function getCounts() {
    const userdata = JSON.parse(localStorage.getItem('user'));
    const user_name = userdata.wallet.username;
    return await fetchAPI('getCounts', 'POST', { user_name });
}

export async function getCustomFilterEmails(type, object) {
    const userdata = JSON.parse(localStorage.getItem('user'));
    const user_name = userdata.wallet.username;
    return await fetchAPI('getCustomFilterEmails', 'POST', { user_name, type, object });
}

export async function getCategoryFilterEmails(categoryId, object) {
    const userdata = JSON.parse(localStorage.getItem('user'));
    const email = userdata.wallet.username;
    return await fetchAPI('getCategoryFilterEmails', 'POST', { email, categoryId, object });
}

export async function existEmail(email) {
    return await fetchAPI('existEmail', 'POST', { email });
}

export async function sendVerifyOtp(type, email, otp = null) {
    return await fetchAPI('sendVerifyOtp', 'POST', { type, email, otp });
}

export async function changePassword(password, email) {
    return await fetchAPI('updatePassword', 'POST', { password, email });
}